import React from 'react'
import { Link } from 'react-router-dom'
import styles from 'src/styles/common.module.sass'
import Typography from 'src/lib/ui/Typography'
import myReportViewStyles from '../YourReportsView.module.sass'
import StoryRiver from 'src/components/StoryRiver'

export const NoReportsFoundView = () => {
  return (
    <StoryRiver title={'Your FirstWord Reports'} titleType="title">
      <div className={myReportViewStyles.description}>
        <Typography variant="body1">
          You currently do not have any FirstWord Reports available to you.{' '}
          <Link to="/contact-us" className={styles.activeLink}>
            Contact Us
          </Link>{' '}
          to learn more about our reports and how you gain access.
        </Typography>
      </div>
    </StoryRiver>
  )
}

export default NoReportsFoundView
